import { Dialog } from '@noorden-insurtech/alba-design-system';
import { MessageSquareText } from 'lucide-react';
import { InspectionInteractionsTimeline } from './inspection-steps/inspection-interactions-timeline.component';

interface InspectionInteractionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  policyId?: string | null;
  inspectionId?: string | null;
}

export function InspectionInteractionsModal({
  isOpen,
  onClose,
  policyId,
  inspectionId,
}: InspectionInteractionsModalProps) {
  const hasIds = Boolean(policyId?.trim() && inspectionId?.trim());

  return (
    <Dialog.Root open={isOpen} onOpenChange={() => onClose()}>
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content className='max-w-3xl'>
          <Dialog.Header>
            <Dialog.Title>
              <MessageSquareText className='h-6 w-6' />
              Registro de Interações
            </Dialog.Title>
            <Dialog.CloseButton onClick={() => onClose()} />
          </Dialog.Header>

          <Dialog.Body className='max-h-[60vh] overflow-y-auto'>
            {!hasIds ? (
              <div className='py-6 text-center text-alba-gray-600'>
                Nenhuma inspeção disponível para esta apólice.
              </div>
            ) : (
              <InspectionInteractionsTimeline
                policyId={policyId as string}
                inspectionId={inspectionId as string}
                enabled={isOpen}
                showHeading={false}
              />
            )}
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
}
